import { render, staticRenderFns } from "./EmployeeIndividualLeaveModal.vue?vue&type=template&id=bb3c23c6&scoped=true&"
import script from "./EmployeeIndividualLeaveModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeIndividualLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c23c6",
  null
  
)

export default component.exports